import { TextEmphasisKeys } from '@/constants/enum';
import { textAppereances, textEmphasis, textSizes } from '@/constants/textStyles';
import { IStateCheckoutRule } from '@/pages/Checkout/components/CreateUpdate';
import parse from 'html-react-parser';
import { memo, useMemo } from 'react';
import { CheckoutMethodRadioStyled } from './styled';
import { InlineStack } from '@shopify/polaris';
interface IProps {
  id: number;
  name: string | React.ReactNode;
  estText: string;
  checked: boolean;
  onChange: (e: boolean) => void;
  showRadioInput?: boolean;
  data?: IStateCheckoutRule;
  icon?: string;
}

const CheckoutMethodRadio = ({ showRadioInput = true, data, ...props }: IProps) => {
  const { textAppearance, textSize, textEmphasis: textStyle } = data || {};

  const fontSize = useMemo(() => {
    return textSizes.find((item) => item.id === textSize)?.fontSize;
  }, [textSize]);

  const textColor = useMemo(() => {
    return textAppereances.find((item) => item.id === textAppearance)?.color;
  }, [textAppearance]);

  const fontWeight = useMemo(() => {
    return textEmphasis.find((item) => item.id === textStyle)?.style;
  }, [textStyle]);

  if (!data) return <>Select rule</>;

  return (
    <CheckoutMethodRadioStyled
      style={
        props.checked
          ? {
              border: '1px solid #DEDEDE',
              backgroundColor: '#ffffff',
              padding: '12px 12px 12px 1rem',
            }
          : {
              border: '1px solid #DEDEDE',
              backgroundColor: '#ffffff33',
              padding: '12px 12px 12px 1rem',
            }
      }
      onClick={() => props.onChange(!props.checked)}
      className={`cursor-pointer ${showRadioInput ? '' : 'ot-estimated-shipping-item-shipping-method-hide-radio'}`}
    >
      <input
        className="ot-estimated-shipping-item-radio ot-estimated-shipping-shipping-methods-select-item"
        key={props.id}
        id={props.id.toString()}
        type={'radio'}
        name={'check_shipping_method'}
        checked={props.checked}
        style={{ accentColor: textColor, backgroundColor: '#ffffff' }}
        readOnly
      />
      {showRadioInput ? <label className="ot-est-lable-checkout-input mt-2" htmlFor={props.id.toString()}></label> : null}

      <div className="d-flex flex-column" style={{ marginLeft: '0.25rem' }}>
        <p>{props.name || 'Shipping method name'}</p>

        <div
          style={{
            fontSize: fontSize,
            color: textColor,
            fontWeight: fontWeight === TextEmphasisKeys.bold ? 'bold' : undefined,
            fontStyle: fontWeight === TextEmphasisKeys.italic ? 'italic' : undefined,
          }}
          className="d-flex align-center mt-4"
        >
          <InlineStack gap={'100'} blockAlign={'center'}>
            {props.icon ? parse(props.icon) : null}
            <span>{parse(typeof props.estText === 'string' ? props.estText : '')}</span>
          </InlineStack>
        </div>
      </div>
    </CheckoutMethodRadioStyled>
  );
};

export default memo(CheckoutMethodRadio);
